import { SearchAddressResponseItem } from "../../../../../../../../../common/utils/search-address/search-address.response";
import PassengerAddressAddTemporaryAddress from "../types/passenger-form-data-address-proposition";
import PassengerFormDataAddressPropositionSelectOption from "../types/passenger-form-data-address-select-option";

const createAddress = (
  searchAddressResponseItem: SearchAddressResponseItem
): PassengerAddressAddTemporaryAddress => {
  return {
    displayName: searchAddressResponseItem.display_name,
    apartmentNumber: "",
    country: searchAddressResponseItem.address.country,
    countryCode: searchAddressResponseItem.address.country_code,
    houseNumber: searchAddressResponseItem.address.house_number ?? null,
    latitude: Number(searchAddressResponseItem.lat),
    longitude: Number(searchAddressResponseItem.lon),
    street: searchAddressResponseItem.address.road ?? null,
    town:
      searchAddressResponseItem.address.city ??
      searchAddressResponseItem.address.town ??
      searchAddressResponseItem.address.village ??
      null,
    zipCode: searchAddressResponseItem.address.postcode ?? null,
  };
};

const createAddressSelectOption = (
  searchAddressResponseItem: SearchAddressResponseItem
): PassengerFormDataAddressPropositionSelectOption => {
  const address = createAddress(searchAddressResponseItem);

  return {
    label: searchAddressResponseItem.display_name,
    value: address,
  };
};

const createAddressSelectOptions = (
  searchAddressResponseItems: SearchAddressResponseItem[]
): PassengerFormDataAddressPropositionSelectOption[] => {
  return searchAddressResponseItems.map(createAddressSelectOption);
};

const passengerAddAddressFactory = {
  createAddress,
  createAddressSelectOptions,
};

export default passengerAddAddressFactory;
